export const GoogleRatingBadge = {
  flow: 'x',
  gap: 'Z',
  align: 'center center',
  padding: 'Y Z',
  round: 'Z',
  background: 'inkMid',
  border: '1px solid inkBorder',
  width: 'fit-content',

  GoogleIcon: {
    tag: 'img',
    width: 'A',
    height: 'A',
    flexShrink: '0',
    attr: { src: 'https://www.google.com/favicon.ico', alt: 'Google' }
  },

  RatingInfo: {
    flow: 'x',
    gap: 'W',
    align: 'center center',

    StarIcon: { extends: 'Icon', icon: 'star', width: 'Z', height: 'Z', color: 'amber' },

    RatingVal: {
      text: (el, s) => String(s.googleRating || '4.8'),
      fontSize: 'Z',
      fontWeight: '700',
      color: 'inkText'
    },

    ReviewCount: {
      text: (el, s) => '(' + (s.googleReviews || 0) + ')',
      fontSize: 'Y',
      color: 'inkMuted'
    }
  },

  ViewLink: {
    extends: 'Link',
    text: '{{ viewOnGoogle | polyglot }}',
    href: (el, s) => s.googleUrl || '#',
    attr: { target: '_blank', rel: 'noopener noreferrer' },
    fontSize: 'Y',
    fontWeight: '500',
    color: 'teal',
    textDecoration: 'none',
    marginLeft: 'Y',
    ':hover': { textDecoration: 'underline' }
  }
}
